<div id="outer" class="well container">
    <div class="well-title">
        <div class="col-md-12" style="display: flex; justify-content: space-between; align-items: center">
            <span>View Scans</span>
            <button nz-button nzType="default" nzSize="small" nzShape="round" (click)="refresh()">
                <i class="fa-solid fa-arrows-rotate" style="color: #52c41a; margin-right: 6px"></i>Refresh
            </button>
        </div>
    </div>
    <div class="col-md-12 well-content scan-well-content">
        <div
            style="display: none; position: fixed; z-index: 110; left: 400px; top: 100px; width: 15px; height: 15px"
            id="preview_div"></div>

        <div style="display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #ddd">
            <ul class="nav nav-tabs" style="border-bottom: none">
                <li role="presentation" [class.active]="activeTab === 'scans'">
                    <a routerLink="/scan">Scans</a>
                </li>
                <li role="presentation" [class.active]="activeTab === 'jobs'">
                    <a routerLink="/scan/jobs">Jobs</a>
                </li>
            </ul>
            <a target="_blank" href="assets/PerFormaDocumentSeparator.pdf">Barcode Separator Page</a>
        </div>

        <div style="padding-top: 20px">
            @if (activeTab === "scans") {
                <app-scan-list-tab></app-scan-list-tab>
            }
            @if (activeTab === "jobs") {
                <app-scan-jobs-tab></app-scan-jobs-tab>
            }
        </div>
    </div>
</div>
